import type { v2 } from '@sap/ux-specification-types';
import { getAppSettingOBJPathV2, getChartSettingsOBJsectionPathV2 } from '../../application';
import { syncRule, validity } from '../../../common/decoration/decorators';

export class ObjectPageChart implements v2.ObjectPageChart {
    @syncRule({
        manifest: {
            path: getChartSettingsOBJsectionPathV2
        }
    })
    @validity({
        since: '1.78.0'
    })
    variantManagement?: boolean;
}

export class GlobalChartSettings implements v2.GlobalChartSettings {
    @syncRule({
        manifest: {
            path: (pageKeys: string[]): string => getAppSettingOBJPathV2(pageKeys) + '/chartSettings'
        }
    })
    @validity({
        since: '1.78.0'
    })
    variantManagement?: boolean;
}
